import React, { useState } from "react";
import { useMutation } from "react-query";
import { _api_send_feedback } from "../../../../api/feedback";
import { toast } from "sonner";

const useCardFeatureFeedBack = () => {
    const [open, setOpen] = useState(false);
    const [type, setType] = useState(null);
    const [message, setMessage] = useState("");

    const disableConfirmButton = type === null || message === "";

    const { mutate, isLoading } = useMutation((data) =>
        _api_send_feedback(data)
    );

    const handleSubmit = () => {
        return mutate(
            {
                type,
                message,
            },
            {
                onSuccess: (data) => {
                    if (data?.success) {
                        setOpen(false);
                        setType(null);
                        setMessage("");
                        return toast.success("Merci pour votre feedback 👌");
                    }
                },
            }
        );
    };

    const closeDialog = () => {
        return setOpen(false);
    };

    const openDialog = () => {
        return setOpen(true);
    };

    const handleChangeType = (_, i) => {
        setType(i.value.id);
    };

    const handleChangeText = (e, i) => {
        e.preventDefault();
        setMessage(i.value);
    };

    return {
        dialog: {
            open,
            closeDialog,
            openDialog,
        },
        ui: {
            disable_confirm_button: disableConfirmButton,
            handleChangeType,
            handleChangeText,
        },
        mutation: {
            mutate,
            isLoading,
        },
        functions: {
            handleSubmit,
        },
    };
};

export default useCardFeatureFeedBack;
